import React from 'react';
import { P2Alert, P2Button, P2Checkbox, P2TextDescription, P2TextInput, P2TextLabel } from 'react-bootstrap-common-script';
import { Separator } from '../../../components/separator';
import { useNavigate } from 'react-router-dom';
import { SectionCard } from '../../../components/card';
import { Stepper } from '../../../components/stepper';
import { R2stepperItemsStageE } from '../../../utils/shared-dropdown';
import { useAppSelector } from '../../../redux/hook';
import { InfoCircle } from '../../../assets/svg';
import { HealthDeclarationItems } from '../../../utils/shared-radio';
import ApplicationCooLayout from '../../../layout/application-coo-layout';
import OverViewSegment from '../cpf-step-1/overview-segment';
import Step2SummarySegment from '../cpf-step-2/segments/summary';
import RadioGroup from '../../../components/form/grouped/radio/radio-group';
import CpfInstalmentPlan from '../cpf-step-2/segments/cpf-instalment';
import CpfWithdrawalDetails from '../cpf-step-2/segments/cpf-withdrawal';
import ShareCover from '../cpf-step-3/segments/share-cover';
import { PolymerAxios } from '../../../utils/axios';
import { API_SubmitEService } from '../../../utils/api';
import { useEffect } from 'react';
import { useGetCpfWithdrawalDetailsQuery } from '../../../redux/services/getStageE';
import useViewportWidth from '../../../components/stepper/useViewportWidth';
import { PolymerCrypto } from '../../../utils/encryptor';
const activeStep = 4;

function StageEConfirmationDeclaration() {
  const isDesktopView = useViewportWidth();
  const navigate = useNavigate();

  // Extract query parameters
  const queryParameters = new URLSearchParams(window.location.search);
  const applicationId = queryParameters.get('application_id') ?? '0';

  // Redux selectors
  const loginUser = useAppSelector((state) => state.auth.AuthenticationSlice.loginUser) ?? '';
  const singpassToken = useAppSelector((state) => state.auth.AuthenticationSlice.singpassToken) ?? '';
  const healthDeclarationFormData = useAppSelector((state) => state.app.ApplicationStageESlice.formData);
  const selectedCpfFormSN = useAppSelector((state) => state.app.ApplicationStageESlice.stage_e_selected_form_sn);
  const selectedCpfFormUUID = useAppSelector((state) => state.app.ApplicationStageESlice.select_cpf_form_uuid);
  const step3formData = useAppSelector((state) => state.app.ApplicationStageESlice.step3formData);
  const application_id = queryParameters.get('application_id');

  const { data: cpfWithdrawalDetails } = useGetCpfWithdrawalDetailsQuery({
    application_id: application_id ?? '0',
    uinfin: loginUser.uinfin ?? '',
    singpass_token: singpassToken ?? '0',
    request_uuid: selectedCpfFormUUID ?? [],
  });

  const cpfAccountNumber = PolymerCrypto.decryption(cpfWithdrawalDetails?.nric);

  React.useEffect(() => {
    // If no selected serial number, redirect
    if (!selectedCpfFormSN || selectedCpfFormSN.length === 0) {
      // navigate(`/`);
    }
  }, [selectedCpfFormSN, navigate]);

  const handleNavigateBack = () => {
    navigate(`/application-coo/stage-e/home-protection-scheme?application_id=${applicationId}`);
  };

  // Ensure user does not try to submit null data
  useEffect(() => {
    if (!step3formData) {
      navigate(`/application-coo/stage-e/home-protection-scheme?application_id=${applicationId}`);
    }
  }, [step3formData]);

  const handleSubmitEService = async () => {
    try {
      // When radio buttons are empty, it means HPS form is not filled (Data logic done in step3)
      const areRadioButtonsEmpty = !healthDeclarationFormData.radio_1 || !healthDeclarationFormData.radio_2 || !healthDeclarationFormData.radio_3;

      const eServicePayload = {
        requestUuid: selectedCpfFormUUID,
        submitted_form_serial_numbers: selectedCpfFormSN,
        eHPSApplied: !areRadioButtonsEmpty,
        declaration_health: healthDeclarationFormData.radio_1 === 'Y' ? true : false,
        declaration_health_details: healthDeclarationFormData.input_1,
        declaration_undergone: healthDeclarationFormData.radio_2 === 'Y' ? true : false,
        declaration_undergone_details: healthDeclarationFormData.input_2,
        declaration_intending: healthDeclarationFormData.radio_3 === 'Y' ? true : false,
        declaration_intending_details: healthDeclarationFormData.input_3,
        socPercent: step3formData?.hpsCoverageForLoginUser,
      };

      console.log('DEBUG | Submit payload: ', eServicePayload);

      const res = await PolymerAxios(loginUser.uinfin, singpassToken).post(`${API_SubmitEService}/${applicationId}`, eServicePayload);
      if (res.status === 200) {
        navigate(`/application-coo/stage-e/submit-overview?application_id=${applicationId}`, {
          state: { transaction_timestamp: res.data.transaction_timestamp },
        });
      }
    } catch (e) {
      alert('An error occurred while submitting the CPF form. Please try again later.');
      console.error('Error fetching data:', e);
    }
  };

  return (
    <ApplicationCooLayout title={'Application for Use of CPF Savings and HPS for Change in Flat Ownership'}>
      <div className='polymer-application-coo__wrapper cpf-wrapper'>
        <div>
          <Stepper activeStep={4} items={R2stepperItemsStageE} />
        </div>

        <div className='d-flex flex-column align-items-center gap-3 gap-md-5 polymer-stage-a5-section-card'>
          <SectionCard
            required={true}
            className='flex-fill'
            activeStep={activeStep}
            stepperItems={[{ id: 4, title: 'Confirmation & Declaration', link: '/application-coo/stage-e/overview' }]}
            titleChildren={<P2TextDescription size={'1.5rem'} title={R2stepperItemsStageE[activeStep - 1]?.title} />}
            contentChildren={
              <div className='polymer-stage-e'>
                <div className='cpf-container'>
                  <P2TextLabel bold={700} label={'Overview of Ownership Change'} fontSize={'24px'} lineHeight={'28px'} />
                  <P2TextLabel label={'Summary'} fontSize={'22px'} lineHeight={'24px'} />
                  <OverViewSegment
                    loginUserUinfin={loginUser?.uinfin ?? ''}
                    applicationId={applicationId ?? '0'}
                    singpassToken={singpassToken ?? ''}
                  />
                </div>

                <Separator variant='solid' style={{ margin: '1.5rem 0' }} />

                <div className='cpf-container'>
                  <P2TextLabel bold={700} label={'Request for Use of CPF Savings'} fontSize={'24px'} lineHeight={'28px'} />
                  <P2TextLabel bold={700} label={'Summary'} fontSize={'22px'} lineHeight={'24px'} />
                  <Step2SummarySegment
                    selectedCpfFormSN={selectedCpfFormSN}
                    cpfAccountNumber={cpfAccountNumber}
                    loginUserUinfin={loginUser?.uinfin}
                    applicationId={applicationId ?? '0'}
                    singpassToken={singpassToken ?? ''}
                  />

                  {/* Check Box */}
                  <div className='polymer-stage-e_checkbox-wrapper_disabled'>
                    <P2Checkbox variant={'disabled'} isActive={true} />
                    <div>
                      <P2TextLabel label={'I agree and authorise:'} fontSize={'18px'} lineHeight={'24px'} />
                      <ol className='polymer-stage-e_ordered-list-wrapper'>
                        <li>
                          the Housing and Development Board ("HDB") to have access to and obtain from the Central Provident Fund Board (the "Board")
                          any information relating to my Central Provident Fund ("CPF") account for any purpose relating to or in connection with this
                          application.
                        </li>
                        <br />
                        <li>
                          the CPF Board to disclose any information regarding my CPF account to HDB for any purpose relating to or in connection with
                          this application, and to pay the amount applied by me directly to HDB.
                        </li>
                        <br />
                        <li>
                          that the acceptance of the application by the CPF Board does not imply that the CPF Board will approve the withdrawal(s)
                          applied for.
                        </li>
                        <br />
                        <li>
                          that this withdrawal is subject to the provisions of the Central Provident Fund Act (Chapter 36) ("CPF Act") and the
                          subsidiary legislations made thereunder and all such applicable terms and conditions as may be imposed from time to time. I
                          have read, fully understood and agree to comply with and abide by the applicable Terms and Conditions of the CPF Housing
                          Schemes, a copy of which is available at the CPF website.
                        </li>
                        <br />
                        <li>
                          that the amount to be used from my CPF accounts for housing payments for this application will be immediately reserved upon
                          HDB's submission.
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>

                {/* ==== CPF Withdrawal ==== */}
                {/* Overview */}
                <CpfWithdrawalDetails cpfWithdrawalDetails={cpfWithdrawalDetails} />

                {/* Installment Plan */}
                {cpfWithdrawalDetails?.instalment?.amount_paid_by_cpf > 0 && (
                  <div>
                    <CpfInstalmentPlan cpfWithdrawalDetails={cpfWithdrawalDetails} />
                  </div>
                )}
                <Separator variant='solid' style={{ margin: '0 0 1.5rem 0' }} />

                {/* ==== HPS ==== */}
                <div className='cpf-container' style={{ gap: '16px' }}>
                  <P2TextLabel bold={700} label={'Application for Home Protection Scheme (HPS) Cover'} fontSize={'1.5rem'} lineHeight={'1.75rem'} />

                  {/* HPS Not Required */}
                  {!step3formData?.hpsRequired && (
                    <P2Alert
                      variant='warning'
                      withBorder
                      text='You are not required to be insured under HPS, since you are not taking any new HDB loan to finance the change in flat ownership.'
                    />
                  )}

                  {/* Zero Coverage Encouragement */}
                  {step3formData?.hpsRequired && step3formData?.isLoginUserZeroCoverage && (
                    <P2Alert
                      variant='warning'
                      withBorder
                      text={
                        <p>
                          You are encouraged to be insured under HPS, even if you are using cash for your monthly housing instalments.
                          <br />
                          <br />
                          If you have an existing HPS cover but have reviewed that you do not need the financial protection provided by HPS, you may
                          terminate your existing HPS cover through CPF Board's website &gt; My Request &gt; Home Protection Scheme (HPS) {'>'}{' '}
                          Terminate my HPS cover.
                        </p>
                      }
                    />
                  )}
                </div>

                {step3formData?.hpsRequired && !step3formData?.isLoginUserZeroCoverage && (
                  <div className='cpf-container'>
                    <P2TextLabel bold={700} label={'Part A'} fontSize={'1.25rem'} lineHeight={'1.5rem'} />
                    <ShareCover hpsCoverage={step3formData?.hpsCoverageForLoginUser} />
                    <P2TextLabel bold={700} label={'Part B'} fontSize={'1.25rem'} lineHeight={'1.5rem'} />
                    <div className='polymer-stage-e_step-3_summary-info'>
                      <div className='info-svg'>
                        <InfoCircle />
                      </div>
                      <div className='info-list'>
                        <div className='info-title'>Note:</div>
                        <p>
                          You must disclose all information which you know or ought to know, that may affect your cover under HPS, so it is compulsory
                          to answer all questions below. You must inform the CPF Board immediately if there is a change in the state of your health
                          before this policy is issued to you.
                        </p>
                      </div>
                    </div>
                    <div className='polymer-stage-e_part-b'>
                      <div className='polymer-stage-e_part-b_medical-option'>
                        <div>
                          <P2TextLabel bold={700} label={'1.'} fontSize={'18px'} lineHeight={'28px'} />
                        </div>
                        <div className='polymer-stage-e_part-b_medical-option_q'>
                          <RadioGroup
                            required={true}
                            r2Enabled={true}
                            gap={8}
                            label='Have you ever suffered or been treated for, or do you now suffer from medical condition such as cancer, tumour, high cholesterol, high blood pressure, diabetes, heart disorder, stroke, asthma, fits, depression, hepatitis, HIV infection, drug or alcohol addictions, disease or disorder of the brain, bone, muscle, spine, kidney, blood, liver, thyroid, or lung, or any other ailment, disorder, physical or mental impairment not mentioned here?'
                            layout='default'
                            items={HealthDeclarationItems}
                            value={healthDeclarationFormData.radio_1}
                            disabled={true}
                          />
                          {healthDeclarationFormData.input_1 && (
                            <div className='polymer-stage-e_part-b_medical-option_input'>
                              <P2TextInput
                                disabled={true}
                                value={healthDeclarationFormData.input_1}
                                name='name'
                                placeholder='Please specify your medical conditions.'
                                type='text'
                              />
                            </div>
                          )}
                        </div>
                      </div>

                      <div className='polymer-stage-e_part-b_medical-option'>
                        <div>
                          <P2TextLabel bold={700} label={'2.'} fontSize={'18px'} lineHeight={'28px'} />
                        </div>
                        <div className='polymer-stage-e_part-b_medical-option_q'>
                          <RadioGroup
                            required={true}
                            r2Enabled={true}
                            gap={8}
                            label='Have you undergone any surgery, treatment, or had any medical test or investigation carried out in the past 5 years?'
                            layout='default'
                            items={HealthDeclarationItems}
                            value={healthDeclarationFormData.radio_2}
                            disabled={true}
                          />
                          {healthDeclarationFormData.input_2 && (
                            <div className='polymer-stage-e_part-b_medical-option_input'>
                              <P2TextInput
                                disabled={true}
                                value={healthDeclarationFormData.input_2}
                                name='name'
                                placeholder='Please specify your medical conditions.'
                                type='text'
                              />
                            </div>
                          )}
                        </div>
                      </div>

                      <div className='polymer-stage-e_part-b_medical-option'>
                        <div>
                          <P2TextLabel bold={700} label={'3.'} fontSize={'18px'} lineHeight={'28px'} />
                        </div>
                        <div className='polymer-stage-e_part-b_medical-option_q'>
                          <RadioGroup
                            required={true}
                            r2Enabled={true}
                            gap={8}
                            layout='default'
                            label='Are you intending to go for any medical consultation, surgery, treatment, medical test or investigation in the next 1 year?'
                            items={HealthDeclarationItems}
                            value={healthDeclarationFormData.radio_3}
                            disabled={true}
                          />
                          {healthDeclarationFormData.input_3 && (
                            <div className='polymer-stage-e_part-b_medical-option_input'>
                              <P2TextInput
                                disabled={true}
                                value={healthDeclarationFormData.input_3}
                                name='name'
                                placeholder='Please specify your medical conditions.'
                                type='text'
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <p className='polymer-stage-e_18pt_description'>
                      Please be informed that you may be required to undergo a medical examination and the CPF Board may request a copy of the medical
                      report on your health condition.
                    </p>
                  </div>
                )}
              </div>
            }
          />
          {/* Seperator */}
          <div className='cpf-wrapper_seperator'>
            <Separator />
          </div>

          {/* Button Group */}
          <div className='cpf-wrapper_button-wrapper'>
            <div className='cpf-wrapper_button-group'>
              <P2Button onClick={() => handleNavigateBack()} variant={'outline-primary'}>
                Back
              </P2Button>
              <P2Button onClick={() => handleSubmitEService()} variant={'primary-1'}>
                Submit
              </P2Button>
            </div>
          </div>
        </div>
      </div>
    </ApplicationCooLayout>
  );
}

export default StageEConfirmationDeclaration;
